import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import 'boxicons';

const Navbar = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isTableDropdownOpen, setTableDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const tableDropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setDropdownOpen(prevState => !prevState);
  };

  const toggleTableDropdown = () => {
    setTableDropdownOpen(prevState => !prevState);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
    if (tableDropdownRef.current && !tableDropdownRef.current.contains(event.target)) {
      setTableDropdownOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('LOGGED_IN'); // Remove item from localStorage
    navigate('/'); // Redirect to home or login page
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      
      <ul>
        <li><Link to="/Calendar"><box-icon name='calendar' color='#ffffff' size='md'></box-icon></Link></li>
        <li className="dropdown" ref={dropdownRef}>
          <button onClick={toggleDropdown} className="dropdown-button"><box-icon name='message-alt-add' color='#ffffff' size='md'></box-icon></button>
          {isDropdownOpen && (
            <ul className="dropdown-menu">
              <li><Link to="/AddEvent"><box-icon name='component' type='solid' color='#000000' ></box-icon> DODAJ USŁUGĘ</Link></li>
              <li><Link to="/AddEmployee"><box-icon name='briefcase' color='#000000'></box-icon> DODAJ PRACOWNIKA</Link></li>
              <li><Link to="/AddProduct"><box-icon name='spray-can'></box-icon> DODAJ PRODUKT</Link></li>
              <li><Link to="/AddClient"><box-icon name='user-circle' ></box-icon> DODAJ KLIENTA</Link></li>
              {/* <li><Link to="/AddToDatabase">ELEMENT DO BAZY DANYCH</Link></li> */}
            </ul>
          )}
        </li>
        <li className="dropdown" ref={tableDropdownRef}>
          <button onClick={toggleTableDropdown} className="dropdown-button"><box-icon name='table' color='#ffffff' size='md' ></box-icon></button>
          {isTableDropdownOpen && (
            <ul className="dropdown-menu">
              <li><Link to="/TableEmployees"><box-icon name='briefcase'></box-icon> TABELA PRACOWNIKÓW</Link></li>
              <li><Link to="/TableClients"><box-icon name='user-circle' ></box-icon> TABELA KLIENTÓW </Link></li>
              <li><Link to="/TableProducts"><box-icon name='spray-can'></box-icon> TABELA PRODUKTÓW</Link></li>
              <li><Link to="/TableData"><box-icon name='data' type='solid'></box-icon> TABELA DANYCH</Link></li>
              </ul>
          )}
        </li>
        <li><a target='_blank' href='https://kalendarz-a4c58-default-rtdb.europe-west1.firebasedatabase.app' rel="noopener noreferrer"><box-icon name='hot' type='solid' color='#ffffff' size='md'></box-icon></a></li>
        <li><Link to="/"><box-icon name='log-out' onClick={handleLogout} color='#ffffff' size='md' ></box-icon></Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
